module.exports = __webpack_public_path__ + "static/media/soldemexico_-4noviembre.a6c58ab1.jpg";